(() => {
  const params = new URLSearchParams(window.location.search);
  const gender = (params.get('gender') || '').toLowerCase();

  // El catálogo CHIKAS ya filtra por género/silueta: no tocar el grid ahí
  // (si no, se oculta .product y queda el hueco del .catalog-item).
  if (document.querySelector('[data-chikas-catalog]')) return;

  if (!gender || (gender !== 'dama' && gender !== 'caballero')) return;

  const cards = document.querySelectorAll('.product-grid .product, .product-grid__cell, [data-catalog-item]');
  if (!cards.length) return;

  const match = (text, g) => {
    const t = (text || '').toLowerCase();
    if (g === 'caballero') {
      return /caballero|hombre|masculino|\bmen\b|\bmale\b/.test(t);
    }
    return /dama|mujer|femenino|lady|women|woman/.test(t) && !/caballero|hombre|masculino/.test(t);
  };

  let shown = 0;
  cards.forEach((cell) => {
    const product = cell.classList.contains('product') ? cell : cell.querySelector('.product');
    const shell = cell.closest('[data-catalog-item]') || cell;
    const blob = [
      product?.querySelector('.product-title')?.textContent,
      product?.querySelector('.ref')?.textContent,
      product?.querySelector('.label')?.textContent,
      product?.dataset?.gender,
      product?.getAttribute('aria-label'),
      shell?.dataset?.gender,
    ].join(' ');
    const ok = match(blob, gender);
    shell.hidden = !ok;
    shell.classList.toggle('chikas-gender-hide', !ok);
    if (ok) shown += 1;
  });

  if (shown === 0) {
    const grid = document.querySelector('.product-grid');
    if (grid && !grid.querySelector('.catalog-empty')) {
      const p = document.createElement('p');
      p.className = 'catalog-empty';
      p.textContent =
        gender === 'caballero'
          ? 'No hay productos Caballero visibles. Revisa que el nombre o tipo diga Caballero.'
          : 'No hay productos Dama visibles. Revisa que el nombre o tipo diga Dama.';
      grid.appendChild(p);
    }
  }
})();
